// @flow
import * as React from "react"
import Error from "./Error"

import {containers} from "@swarm2/core"

const NumRender = props => {
  if (props.isError) return <Error inline error={props} />
  const {val, hideblank, formatNumber, error, ...opts} = props
  if (hideblank && val === undefined) return null
  return <span>{formatNumber(val, opts)}</span>
}
export const withFormatNumber = containers.common.Number
export const Num = withFormatNumber(NumRender)

export const Short = (props: Object) => <Num {...props} flavor="short" />

//Num.propTypes = {
//  val: React.PropTypes.oneOfType([  // no isRequired, because hideblank allows undefined
//    React.PropTypes.object, // decimal.js
//    React.PropTypes.number,
//    React.PropTypes.string,
//  ]),
//  small: React.PropTypes.bool,
//  sigfigs: React.PropTypes.number,
//  hideblank: React.PropTypes.bool,
//  format: React.PropTypes.string,
//}

export const Percent = (props: Object) => {
  let {hideblank, val, minusone} = props
  if (hideblank && val === undefined) return null
  if (minusone) val -= 1
  // Not sure why <Num> is freezing up here...
  return <span>{Math.round(val * 100)}%</span>
  //return <span><Num val={val * 100} />%</span>
}
export const DPercent = (props: Object) => {
  return Percent({...props, val: props.val.toNumber()})
}



// WEBPACK FOOTER //
// ./src/common/Number.js